import React, { useEffect, useState } from "react";
import MapDocumentModal from "../updatedocuments/mapDocumentsModal";
import { Paper, Switch } from "@mui/material";
import "./MapDocumentsNewPage.scss";
import Setparamtermodal from "./Setparamtermodal";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { logOut } from "../../../config/user";
import { CaseServices } from "../../../services/CaseServices";
import { CircularProgress } from "@mui/material";
import EditIcon from "../../../assets/editIcon.svg";
import { DateTimePicker } from "../../../utils/dateTimePicker";
// import CountdownTimer from "../../../utils/countDownTimer";
import { useSelector } from "react-redux";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";

const MapDocumentsNewPage = ({
  refreshPage,
  hsaStage,
  setPaper,
  caseId,
  setValue,
  functionalityType,
  csProcedures,
  caseType,
  caseStage,
}) => {
  const [caseProcedures, setCaseProcedures] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [documents, setDocuments] = useState({});
  const [admissionDocuments, setAdmissionDocuments] = useState(null);
  const [duringTreatmentDocuments, setDuringTreatmentDocuments] =
    useState(null);
  const [onDischargeDocuments, setOnDischargeDocuments] = useState(null);
  const [areDocumentsMapped, setDocumentsMapped] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [editAdmissionDocument, setEditAdmissionDocument] = useState(null);
  const currentRole = useSelector((state) => state.currentRole.value);

  const handleRemove = async (header, idx, caseId, documentId, procedureId) => {
    if (caseId) {
      try {
        await CaseServices.deleteDocument(documentId);
        await getDefaultsDocument();
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      let filteredData = documents[`${header}`].filter(
        (doc) => doc.procedureId !== procedureId || doc.id !== documentId,
      );

      documents[`${header}`] = filteredData;
      setDocuments({ ...documents });
    }
  };

  // Helper function to check if map buttons should be hidden
  const shouldHideMapButtons = () => {
    if (!caseStage) return false;

    const stage = caseStage.toLowerCase();
    return (
      stage.includes("admission query on tms") ||
      stage.includes("admission rejected on tms") ||
      stage.includes("enhancement query on tms") ||
      stage.includes("claim query on tms") ||
      stage.includes("enhancement rejected on tms")
    );
  };

  const handleSubmit = async (fromMapped) => {
    setIsSubmitting(true);
    try {
      let destructuredDocs = [
        ...documents.ADMISSIONDOCUMENT,
        ...documents.DURINGTREATMENTDOCUMENT,
        ...documents.ONDISCHARGEDOCUMENT,
      ];
      if (destructuredDocs.length < 1) {
        window.alert("Please map at least one document");
        setIsSubmitting(false);
        return;
      }
      await CaseServices.addMapDocuments(destructuredDocs, caseId);
      if (!fromMapped) {
        window.alert("Documents mapped successfully");
        setValue("ADD DOCUMENTS");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsSubmitting(false);
  };

  const handleUpdate = async (fromMapped) => {
    setIsSubmitting(true);
    try {
      let destructuredDocs = [
        ...documents.ADMISSIONDOCUMENT,
        ...documents.DURINGTREATMENTDOCUMENT,
        ...documents.ONDISCHARGEDOCUMENT,
      ];

      if (destructuredDocs.length < 1) {
        window.alert("Please map at least one document");
        setIsSubmitting(false);
        return;
      }
      await CaseServices.updateMappedDocuments(destructuredDocs, caseId);
      refreshPage();
      if (!fromMapped) {
        window.alert("Documents updated successfully");
        setValue("UPDATE DOCUMENTS");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsSubmitting(false);
  };

  const handleSave = (fromMapped) => {
    functionalityType === "EDIT"
      ? handleUpdate(fromMapped)
      : handleSubmit(fromMapped);
  };

  const handleEdit = (docId) => {
    if (docId === editAdmissionDocument) {
      setEditAdmissionDocument(null);
    } else {
      setEditAdmissionDocument(docId);
    }
  };
  function updateDeadline(date, name, idx) {
    documents[`${name}`][`${idx}`]["deadline"] = date;
    setDocuments({ ...documents });
  }

  const handleUpdateDocRequiredStatus = async (doc) => {
    try {
      await CaseServices.updateDocRequiredStatus(doc.id, !doc?.required);
      await getDefaultsDocument();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  async function getDefaultsDocument() {
    try {
      setIsLoading(true);
      if (functionalityType === "EDIT") {
        let documents = await CaseServices.getMappedDocuments(caseId);
        if (documents?.data?.mappedDocuments && documents?.data?.count > 0) {
          setDocuments(documents?.data?.mappedDocuments);
          setDocumentsMapped(true);
        }
        if (documents?.data?.count == 0) {
          let procedureIds = await csProcedures.map((ids) => ids.procedureId);
          documents = await CaseServices.defaultDocuments(
            procedureIds,
            caseType,
          );
          // Added deadline inside default documents
          let j = 1;
          const currentDate = new Date();
          const deadline = new Date(currentDate.getTime() + 4 * 60 * 60 * 1000);
          for (let i of documents?.data?.defaultCaseDocuments
            .ADMISSIONDOCUMENT) {
            i["deadline"] = deadline;
          }
          setDocuments(documents?.data?.defaultCaseDocuments);
        }
      } else {
        let procedures = await CaseServices.getCaseProcedures(caseId); // caseId
        if (procedures?.data?.caseProcedures) {
          setCaseProcedures(procedures?.data?.caseProcedures);
          let procIds = procedures.data.caseProcedures.map(
            (proc) => proc.procedureId,
          );
          let res = await CaseServices.defaultDocuments(procIds);
          if (res?.data?.defaultCaseDocuments)
            setDocuments(res?.data?.defaultCaseDocuments);
        }
      }
      setIsLoading(false);
    } catch (error) {
      handleApiErrorResponses(error);
      setIsLoading(false);
    }
  }
  const formatData = (data, updateMethod) => {
    data.sort((a, b) => {
      if (a.procedureId < b.procedureId) return -1;
      if (a.procedureId > b.procedureId) return 1;
      return 0;
    });

    const formattedDocument = [];
    const ids = [];
    for (let i of data) {
      const values = [];
      for (let j of data) {
        if (
          i.procedureId === j.procedureId &&
          ids.findIndex((item) => item === i.procedureId) === -1
        ) {
          values.push(j);
        }
      }
      if (values.length > 0) {
        ids.push(i.procedureId);
        formattedDocument.push({
          procedureId: i.procedureId,
          values: values,
        });
      }
    }
    updateMethod(formattedDocument);
  };
  useEffect(() => {
    getDefaultsDocument();
  }, []);
  useEffect(() => {
    if (
      documents &&
      documents?.ADMISSIONDOCUMENT &&
      documents?.ADMISSIONDOCUMENT.length > 0
    ) {
      formatData(documents?.ADMISSIONDOCUMENT, setAdmissionDocuments);
    }
    if (
      documents &&
      documents?.DURINGTREATMENTDOCUMENT &&
      documents?.DURINGTREATMENTDOCUMENT.length > 0
    ) {
      formatData(
        documents?.DURINGTREATMENTDOCUMENT,
        setDuringTreatmentDocuments,
      );
    }
    if (
      documents &&
      documents?.ONDISCHARGEDOCUMENT &&
      documents?.ONDISCHARGEDOCUMENT.length > 0
    ) {
      formatData(documents?.ONDISCHARGEDOCUMENT, setOnDischargeDocuments);
    }
  }, [documents]);

  return (
    <Paper className="map-documents-new-box">
      <div className="btn-container" style={{ justifyContent: "flex-start" }}>
        <select
          name=""
          className="outline-btn"
          style={{ width: "167px", display: "block" }}
        >
          <option value="">SPECIALITY ID</option>
        </select>
        <select
          name=""
          className="outline-btn"
          style={{ width: "171px", display: "block" }}
        >
          <option value="">PROCEDURE ID</option>
        </select>
        <select
          name=""
          className="outline-btn"
          style={{ width: "200px", display: "block" }}
        >
          <option value="">PROCEDURE NAME</option>
        </select>
        <select
          name=""
          className="outline-btn"
          style={{ width: "137px", display: "block" }}
        >
          <option value="">IMPLANTS</option>
        </select>
        <select
          name=""
          className="outline-btn"
          style={{ width: "184px", display: "block" }}
        >
          <option value="">STRATIFICATION</option>
        </select>

        <Setparamtermodal
          caseId={caseId}
          setDocuments={setDocuments}
          documents={documents}
        />

        <ErrorOutlineIcon style={{ height: "32px", color: "#017C57" }} />
      </div>
      <hr
        style={{
          color: "#E7E7E7",
          marginBottom: "32px",
        }}
      />

      <div className="hidden xl:flex text-[#191919] font-semibold mb-4 px-4">
        <div className="w-[20%]">Sr.No.</div>
        <div className="w-[60%] text-left">Document Name</div>
        <div className="w-[20%] text-center">Action</div>
      </div>

      {!isLoading ? (
        <>
          <div>
            {/* Header */}
            <div className="flex flex-col xl:flex-row items-center justify-between gap-4 xl:gap-0">
              <h2 className="text-2xl font-semibold text-[#191919]">
                Admission Documents
              </h2>
              {hsaStage?.toLowerCase()?.includes("admission") &&
                !shouldHideMapButtons() && (
                  <MapDocumentModal
                    documentType="map admission document"
                    caseProcedures={csProcedures}
                    caseId={caseId}
                    getDefaultsDocument={getDefaultsDocument}
                    handleSave={handleSave}
                    areDocumentsMapped={areDocumentsMapped}
                  />
                )}
            </div>

            {/* List */}
            <div className="mt-5">
              {admissionDocuments && admissionDocuments.length ? (
                admissionDocuments.map((document, groupIdx) => (
                  <div key={groupIdx} className="mb-4">
                    <div className="font-semibold text-black mb-2">
                      {document.procedureId}
                    </div>

                    {document.values.map((doc, idx) => (
                      <div
                        key={idx}
                        className="block text-[#797979] xl:flex xl:flex-wrap items-center py-2 px-4 mb-2"
                        style={
                          idx % 2 !== 0
                            ? {
                                backgroundColor: "#F9F9F9",
                                borderRadius: "8px",
                              }
                            : {}
                        }
                      >
                        {/* 20% — Sr.No. */}
                        <div className="xl:w-[20%] text-xl flex items-center">
                          {idx + 1}.
                        </div>
                        {/* 60% — Document Name */}
                        <div className="xl:w-[60%] xl:text-xl flex items-center min-w-0">
                          <span
                            className="block overflow-hidden text-ellipsis whitespace-nowrap text-left"
                            style={{ maxWidth: "500px" }}
                            title={doc.documentName}
                          >
                            {doc.documentName}
                          </span>
                        </div>
                        {/* 20% — Action */}

                        {/* {doc.caseId ? (
                          <div className="xl:w-[20%] flex items-center justify-center">
                            {doc?.required ? (
                              <div className="w-[28px] " />
                            ) : (
                              <DeleteOutlinedIcon
                                sx={{ color: "#FE6234", fontSize: 28 }}
                                onClick={() => {
                                  handleRemove(
                                    "ADMISSIONDOCUMENT",
                                    idx,
                                    doc.caseId,
                                    doc.id,
                                    doc.procedureId,
                                  );
                                }}
                              />
                            )}

                            <div>
                              <Switch
                                checked={doc?.required ? true : false}
                                onChange={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to toggle the document status",
                                    )
                                  ) {
                                    handleUpdateDocRequiredStatus(doc);
                                  }
                                }}
                                color="success"
                              />
                            </div>
                          </div>
                        ) : (
                          <DeleteOutlinedIcon
                            sx={{ color: "#FE6234", fontSize: 28 }}
                            onClick={() => {
                              handleRemove(
                                "ADMISSIONDOCUMENT",
                                idx,
                                doc.caseId,
                                doc.id,
                                doc.procedureId,
                              );
                            }}
                          />
                        )} */}

                        <DeleteOutlinedIcon
                          sx={{ color: "#FE6234", fontSize: 28 }}
                          onClick={() => {
                            handleRemove(
                              "ADMISSIONDOCUMENT",
                              idx,
                              doc.caseId,
                              doc.id,
                              doc.procedureId,
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div className="text-[#191919] text-center py-4">
                  No Documents Found
                </div>
              )}
            </div>
          </div>

          <div className="mt-8">
            <div className=" flex flex-col xl:flex-row gap-4 xl:gap-0 justify-between text-2xl font-semibold text-[#191919]">
              Enhancement Documents{" "}
              {(hsaStage?.toLowerCase()?.includes("admission") ||
                hsaStage?.toLowerCase()?.includes("enhancement")) &&
                !shouldHideMapButtons() && (
                  <MapDocumentModal
                    documentType="map during treatment document"
                    caseProcedures={csProcedures}
                    caseId={caseId}
                    refreshPage={refreshPage}
                    getDefaultsDocument={getDefaultsDocument}
                    handleSave={handleSave}
                    areDocumentsMapped={areDocumentsMapped}
                  />
                )}
            </div>
            <div className="mt-5">
              {duringTreatmentDocuments ? (
                duringTreatmentDocuments.map((document, idx) => {
                  return (
                    <div key={idx}>
                      <div className="font-semibold mb-2">
                        {document.procedureId}
                      </div>
                      {document.values.map((doc, idx) => {
                        return (
                          <div
                            key={idx}
                            className="block text-[#797979] xl:flex xl:flex-wrap items-center py-2 px-4 mb-2"
                            style={
                              idx % 2 !== 0
                                ? {
                                    backgroundColor: "#F9F9F9",
                                    borderRadius: "8px",
                                  }
                                : {}
                            }
                          >
                            {/* 20% — Sr.No. */}
                            <div className="xl:w-[20%] text-xl flex items-center">
                              {idx + 1}.
                            </div>

                            {/* 60% — Document Name */}
                            <div className="xl:w-[60%] xl:text-xl flex items-center min-w-0">
                              <span
                                className="block overflow-hidden text-ellipsis whitespace-nowrap text-left"
                                style={{ maxWidth: "500px" }}
                                title={doc.documentName}
                              >
                                {doc.documentName}
                              </span>
                            </div>
                            {/* {doc.caseId ? (
                              <div className="xl:w-[20%] flex items-center justify-center">
                                {doc?.required ? (
                                  <div className="w-[28px] " />
                                ) : (
                                  <DeleteOutlinedIcon
                                    sx={{ color: "#FE6234", fontSize: 28 }}
                                    onClick={() => {
                                      handleRemove(
                                        "DURINGTREATMENTDOCUMENT",
                                        idx,
                                        doc.caseId,
                                        doc.id,
                                        doc.procedureId,
                                      );
                                    }}
                                  />
                                )}

                                <div>
                                  <Switch
                                    checked={doc?.required ? true : false}
                                    onChange={() => {
                                      if (
                                        window.confirm(
                                          "Are you sure you want to toggle the document status",
                                        )
                                      ) {
                                        handleUpdateDocRequiredStatus(doc);
                                      }
                                    }}
                                    color="success"
                                  />
                                </div>
                              </div>
                            ) : (
                              <DeleteOutlinedIcon
                                sx={{ color: "#FE6234", fontSize: 28 }}
                                onClick={() => {
                                  handleRemove(
                                    "DURINGTREATMENTDOCUMENT",
                                    idx,
                                    doc.caseId,
                                    doc.id,
                                    doc.procedureId,
                                  );
                                }}
                              />
                            )} */}
                            <DeleteOutlinedIcon
                              sx={{ color: "#FE6234", fontSize: 28 }}
                              onClick={() => {
                                handleRemove(
                                  "DURINGTREATMENTDOCUMENT",
                                  idx,
                                  doc.caseId,
                                  doc.id,
                                  doc.procedureId,
                                );
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  );
                })
              ) : (
                <div className="text-[#191919] text-center py-4">
                  No Documents Found
                </div>
              )}
            </div>
          </div>
          <div className="mt-8">
            <div className=" flex flex-col xl:flex-row gap-4 xl:gap-0 justify-between text-2xl font-semibold text-[#191919]">
              On Discharge Documents{" "}
              {!shouldHideMapButtons() && (
                <MapDocumentModal
                  documentType="map discharge document"
                  caseProcedures={csProcedures}
                  caseId={caseId}
                  refreshPage={refreshPage}
                  getDefaultsDocument={getDefaultsDocument}
                  handleSave={handleSave}
                  areDocumentsMapped={areDocumentsMapped}
                />
              )}
            </div>
            <div className="mt-5">
              {onDischargeDocuments ? (
                onDischargeDocuments.map((document, idx) => (
                  <div key={idx}>
                    <div className="font-semibold text-black mb-2">
                      {document.procedureId}
                    </div>

                    {document.values.map((doc, idx) => (
                      <div
                        key={idx}
                        className="block text-[#797979] xl:flex xl:flex-wrap items-center py-2 px-4 mb-2"
                        style={
                          idx % 2 !== 0
                            ? {
                                backgroundColor: "#F9F9F9",
                                borderRadius: "8px",
                              }
                            : {}
                        }
                      >
                        {/* 20% — Sr.No. */}
                        <div className="xl:w-[20%] text-xl flex items-center">
                          {idx + 1}.
                        </div>

                        {/* 60% — Document Name */}
                        <div className="xl:w-[60%] xl:text-xl flex items-center min-w-0">
                          <span
                            className="block overflow-hidden text-ellipsis whitespace-nowrap text-left"
                            style={{ maxWidth: "500px" }}
                            title={doc.documentName}
                          >
                            {doc.documentName}
                          </span>
                        </div>

                        {/* 20% — Action */}
                        {/* {doc.caseId ? (
                          <div className="xl:w-[20%] flex items-center justify-center">
                            {doc?.required ? (
                              <div className="w-[28px] " />
                            ) : (
                              <DeleteOutlinedIcon
                                sx={{ color: "#FE6234", fontSize: 28 }}
                                onClick={() => {
                                  handleRemove(
                                    "ONDISCHARGEDOCUMENT",
                                    idx,
                                    doc.caseId,
                                    doc.id,
                                    doc.procedureId,
                                  );
                                }}
                              />
                            )}

                            <div>
                              <Switch
                                checked={doc?.required ? true : false}
                                onChange={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to toggle the document status",
                                    )
                                  ) {
                                    handleUpdateDocRequiredStatus(doc);
                                  }
                                }}
                                color="success"
                              />
                            </div>
                          </div>
                        ) : (
                          <DeleteOutlinedIcon
                            sx={{ color: "#FE6234", fontSize: 28 }}
                            onClick={() => {
                              handleRemove(
                                "ONDISCHARGEDOCUMENT",
                                idx,
                                doc.caseId,
                                doc.id,
                                doc.procedureId,
                              );
                            }}
                          />
                        )} */}
                        <DeleteOutlinedIcon
                          sx={{ color: "#FE6234", fontSize: 28 }}
                          onClick={() => {
                            handleRemove(
                              "ONDISCHARGEDOCUMENT",
                              idx,
                              doc.caseId,
                              doc.id,
                              doc.procedureId,
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div className="text-[#191919] text-center py-4">
                  No Documents Found
                </div>
              )}
            </div>
          </div>
          <div className="btn-container">
            {isSubmitting ? (
              <div className="flex justify-center">
                <CircularProgress />
              </div>
            ) : (
              <button
                onClick={() => handleSave(false)}
                disabled={isSubmitting}
                className="filled-btn"
              >
                SAVE DETAILS
              </button>
            )}
          </div>
        </>
      ) : (
        <div style={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <CircularProgress />
        </div>
      )}
    </Paper>
  );
};

export default MapDocumentsNewPage;
